import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { projectTypePost } from "../../store/projectType/actions";
export var useProjectTypePost = function (trigger, body) {
    var dispatch = useDispatch();
    var _a = useSelector(function (state) {
        var _a;
        return ({
            responseProjectTypePost: (_a = state.ProjectType.responseProjectTypePost) === null || _a === void 0 ? void 0 : _a.data,
            errorProjectTypePost: state.ProjectType.errorProjectTypePost,
            loadingProjectTypePost: state.ProjectType.loadingProjectTypePost,
        });
    }), responseProjectTypePost = _a.responseProjectTypePost, errorProjectTypePost = _a.errorProjectTypePost, loadingProjectTypePost = _a.loadingProjectTypePost;
    useEffect(function () {
        if (trigger) {
            dispatch(projectTypePost({
                clientId: body.data.clientId,
                description: body.data.description,
            }));
        }
    }, [trigger, body.data.clientId]);
    return {
        responseProjectTypePost: responseProjectTypePost,
        errorProjectTypePost: errorProjectTypePost,
        loadingProjectTypePost: loadingProjectTypePost,
    };
};
